import React, { useCallback, useEffect, useState } from 'react';
import { injectIntl } from "react-intl";
import { userAvatar } from '../../utils/images';
import { useHistory, useParams } from 'react-router-dom';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import PhoneInputComponent from '../Controls/PhoneInput/PhoneInput';
import { arabicConvertor } from '../../utils/Shared';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { getCitiesRequest, getRegionsRequest, getCitiesByRegionRequest } from '../../store/usersLabs/actions';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Schedule from './Scheduler';
import { getFamiliesRequest, addFamilyRequest, getPatientRequest, editPatientRequest, validIdRequest, resetValidId } from '../../store/patients/actions';
import { addAppointmentRequest, getAppointmentsByUsersRequest } from '../../store/appointments/actions';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import { requestSourcesReceive, requestSourcesRequest } from '../../store/requests/actions';
import Autocomplete from '@material-ui/lab/Autocomplete';

function PatientProfileForm({ intl: { messages } }) {
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [step, setStep] = useState(1);
    const [addFatherFamily, setAddFatherFamily] = useState(false);
    const [addMotherFamily, setAddMotherFamily] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [familyData, setFamilyData] = useState('');
    const lang = localStorage.getItem('lang');
    // Lists
    const [availableTimes, setAvailableTimes] = useState([]);
    const [specialistList, setSpecialistList] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(0);
    const [selectedBirthDate, setSelectedBirthDate] = useState(moment().format('YYYY-MM-DD'));
    const [selectedAppsDate, setSelectedAppsDate] = useState(moment().format('YYYY-MM-DD'));
    const [selectedTime, setSelectedTime] = useState(moment().format('YYYY-MM-DD'));
    const [selectedUserId, setSelectedUserId] = useState(0);
    const { requestResources } = useSelector((state) => state.requests);
    const [requestResourcesOptions, setRequestResourcesOptions] = useState([]);
    const [patientIDFeedback, setPatientIDFeedback] = useState(null);
    const [citiesList, setCitiesList] = useState([]);
    const { allCities, cities, regions } = useSelector((state) => state?.usersLabs);
    const { families, valideFamilyName, patient, validStep, validId, IDError } = useSelector((state) => state?.patients);
    const { appointmentsByUsers } = useSelector((state) => state?.appointments);
    const [motherInputValue, setMotherInputValue] = useState("");
    const [fatherInputValue, setFatherInputValue] = useState("");
    const [familiesList, setFamiliesList] = useState([{id: 0, name: messages.patients.form.father_link_placeholder}, {id: 'add', name: messages.patients.form.add_new_family}]);
    const [appointment, setAppointment] = useState({
        patient_id: id,
        user_id: 0,
        start_date: '',
        type: 0,
        purpose: 1,
        time: '',
    });
    const relationshipList = [
        {id: 1, name: messages.patients.form.same_family},
        {id: 2, name: messages.patients.form.different_family},
    ];

    const genderList = [
        {id: 1, val: 'Male', name: messages.patients.form.male},
        {id: 2, val: 'Female', name: messages.patients.form.female}
    ];

    const maritalStatus = [
        {id: 1, val: 'Single', name: messages.patients.form.single},
        {id: 2, val: 'Married', name: messages.patients.form.married},
        {id: 3, val: 'Divorced', name: messages.patients.form.divorced},
        {id: 4, val: 'Widow', name: messages.patients.form.widow},
    ];

    const dealingTypes = [
        {id: 1, val: 'Online', name: messages.patients.form.online},
        {id: 2, val: 'Offline', name: messages.patients.form.offline},
    ];

    const programs = [
        {id: 1, name: messages.patients.form.general_program},
        {id: 2, name: messages.patients.form.healthy_family_program},
        {id: 3, name: messages.patients.form.premarital_program},
        {id: 4, name: messages.patients.form.family_wala_program},
    ];

    const appTypes = [
        {id: 2, name: messages.patients.form.video_call},
        {id: 4, name: messages.patients.form.at_office},
        {id: 3, name: messages.patients.form.audio_call},
        {id: 1, name: messages.patients.form.textual_app},
    ]

    const appStatus = [
        {id: 1, name: messages.patients.form.first_app},
        {id: 2, name: messages.patients.form.inquiry_app},
        {id: 3, name: messages.patients.form.explantation_app},
    ]

    const [formData, setFormData] = useState({
        id: null,
        profile_image: "",
        has_family_history: null,
        identification_number: "",
        patient_type: 0,
        test_type: 0,
        first_name: '',
        name: {
            en: '',
            ar: ''
        },
        father_family_id: 0,
        mother_family_id: 0,
        parents_relationship: 0,
        birthday: '',
        birthplace_id: 0,
        origin_city_id: 0,
        gender_type: 0,
        social_status: 0,
        source: 0,
        contact_method: 0,
        program_id: 1,
        email: '',
        phone_number: '',
        city_id: 0,
        region_id: 0,
        address: '',
        with_contacts: false,
        contacts: [],
    });

    useEffect(() => {
        if (!requestResources.length) dispatch(requestSourcesRequest());
        return () => {
          dispatch(requestSourcesReceive([]));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    useEffect(() => {
    //add all option
    if (requestResources.length)
        setRequestResourcesOptions([
        { id: 0, name: messages.requests.all_sources },
        ...requestResources,
        ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestResources]);

    //Get Data
    useEffect(() => {
        if (id && id > 0) {
            dispatch(getPatientRequest(id));
            dispatch(getCitiesRequest());
            dispatch(getRegionsRequest());
            dispatch(getFamiliesRequest());
        }
    }, [dispatch, id]);

    //Select Appointments Date
    useEffect(() => {
        if (selectedAppsDate) {
            setSelectedUserId(0);
            setSpecialistList([]);
            setAvailableTimes([]);
            setFormData({ ...formData, user_id: 0, time: '' });
            dispatch(getAppointmentsByUsersRequest({ date: selectedAppsDate }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, selectedAppsDate]);

    //Select User
    useEffect(() => {
        if (selectedUserId) {
            setSelectedTime(null);
        }
    }, [selectedUserId]);

     //Regions Change
     useEffect(() => {
        if (selectedRegion > 0) {
            dispatch(getCitiesByRegionRequest(selectedRegion));
            setFormData({
                ...formData,
                city_id: 0,
            });
        } else {
            dispatch(getCitiesRequest());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRegion])

    useEffect(() => {
        if (cities && cities.length > 0) {
            setCitiesList(cities)
        }
    }, [cities]);

    //Birthday select
    useEffect(() => {
        if (selectedBirthDate) {
            setFormData({
                ...formData,
                birthday: moment(selectedBirthDate).format("YYYY-MM-DD HH:mm:ss"),
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBirthDate])

    // Users List
    useEffect(() => {
        if (appointmentsByUsers && appointmentsByUsers.length > 0) {
            let list = [];
            appointmentsByUsers.forEach((item) => {
                list.push({
                    id: item.id,
                    name: item.name,
                });
            });
            setSpecialistList(list);
        } else {
            setSpecialistList([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentsByUsers])

    // Set Available Slot times
    useEffect(() => {
        if (selectedUserId) {
            let appTimes = [];
            appointmentsByUsers.forEach(app => {
                if (parseInt(app.id) === parseInt(selectedUserId)) {
                    app.available_appointments?.forEach((time, index) => {
                        appTimes.push({
                            id: index,
                            value: time,
                            text: moment(time, 'HH:mm:ss').format('hh:mm A')
                        });
                    })
                }
            })
            setAvailableTimes(appTimes);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedUserId])

    //Get Patient Data
    useEffect(() => {
        if (patient) {
            setFormData({
                id: patient.id,
                profile_image: patient.profile_image,
                has_family_history: patient.has_family_history === 0 ? 0 : patient.has_family_history === 1 ? 1 : null,
                identification_number: patient.identification_number || "",
                patient_type: patient.patient_type,
                test_type: patient.test_type,
                first_name: patient.first_name || '',
                name: {
                    en: patient.name?.en || '',
                    ar: patient.name?.ar || ''
                },
                father_family_id: patient.father_family_id || 0,
                mother_family_id: patient.mother_family_id || 0,
                parents_relationship: patient.parents_relationship || 0,
                birthday: patient.birthday,
                birthplace_id: patient.birthplace_id || 0,
                origin_city_id: patient.origin_city_id || 0,
                gender_type: patient.gender_type || 0,
                social_status: patient.social_status || 0,
                source: patient.source || 0,
                contact_method: patient.contact_method || 0,
                program_id: patient.program_id || 1,
                email: patient.email || '',
                phone_number: patient.phone_number || '',
                city_id: patient.city_id || 0,
                region_id: patient.region_id || 0,
                address: patient.address || '',
                with_contacts: patient.contacts?.length > 0 ? true : false,
                contacts: patient.contacts || [],
            })
            setSelectedBirthDate(patient.birthday)
            setFatherInputValue(patient.father_family_name);
            setMotherInputValue(patient.mother_family_name);    
        }
    }, [patient]);

    // Validation
    const firstStepValidation = () => {
        let isValid = true;
        if (formData.program_id === 0) {
            document.getElementById('subsPrograms').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.subscription_programs_feedback);
        }
        if (formData.contact_method === 0) {
            document.getElementById('dealingType').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.dealing_type_feedback);
        }
        if (formData.source === 0) {
            document.getElementById('requestChannel').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.request_channel_feedback);
        }
        if (formData.gender_type === 0) {
            document.getElementById('gender').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.gender_feedback);
        }
        if (formData.social_status === 0) {
            document.getElementById('status').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.status_feedback);
        }
        if (formData.birthplace_id === 0) {
            document.getElementById('birthplaceId').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.birth_city_feedback);
        }
        if (formData.origin_city_id === 0) {
            document.getElementById('originCityId').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.city_feedback);
        }
        if (moment(formData.birthday, 'YYYY-MM-DD').diff(moment()) > 0) {
            document.querySelector('.datetime-picker input').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.birthday_feedback);
        }
        if (formData.parents_relationship === 0) {
            document.getElementById('relationship').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.relationship_feedback);
        }
        if (formData.mother_family_id === 0) {
            document.getElementById('motherLink').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.mother_link_feedback);
        }
        if (formData.father_family_id === 0) {
            document.getElementById('fatherLink').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.father_link_feedback);
        }
        if (formData.name?.ar === '') {
            document.getElementById('arname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.ar_name_invalid);
        }
        if (formData.name?.en === '') {
            document.getElementById('enname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.en_name_invalid);
        }
        if (formData.first_name === '') {
            document.getElementById('firstName').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.firstname_placeholder);
        }
        if (formData.identification_number.length < 10 || formData.identification_number.length > 20) {
            //document.getElementById('patientId').style.borderColor = '#d58c8c';
            isValid = false;
            setPatientIDFeedback(messages.patients.form.patientId_feedback);
        }
        if (!formData.has_family_history || !formData.patient_type || !formData.test_type) {
            setFeedback(messages.patients.form.all_fields_required);
        }
        return isValid;
    }

    const secondStepValidation = () => {
        let secondIsValid = true;
        /* if (formData.address === '') {
            document.getElementById('address').style.borderColor = '#d58c8c';
            secondIsValid = false;
            setFeedback(messages.users.form.address_placeholder);
        } */
        if (formData.city_id === '') {
            document.getElementById('cityId').style.borderColor = '#d58c8c';
            secondIsValid = false;
            setFeedback(messages.users.form.city_feedback);
        }
        if (formData.region_id === '') {
            document.getElementById('governorate').style.borderColor = '#d58c8c';
            secondIsValid = false;
            setFeedback(messages.users.form.governorate_feedback);
        }
        /* if (formData.email === '') {
            document.getElementById('email').style.borderColor = '#d58c8c';
            secondIsValid = false;
            setFeedback(messages.users.form.email_placeholder);
        } */
        if (formData.phone_number === '') {
            document.getElementById('phone').style.borderColor = '#d58c8c';
            secondIsValid = false;
            setFeedback(messages.users.form.mobile_placeholder);
        }
        if (formData.phone_number === '' && formData.address === '' && formData.city_id === 0 && formData.region_id === 0) {
            setFeedback(messages.users.form.all_fields_required);
        }
        return secondIsValid;
    }

    const thirdStepValidation = () => {
        let thirdIsValid = true;
        if (appointment?.purpose === 0 ) {
            document.getElementById('appStatus').style.borderColor = '#d58c8c';
            thirdIsValid = false;
            setFeedback(messages.patients.form.app_status_feedback);
        }
        if (appointment?.type === 0) {
            document.getElementById('appTypes').style.borderColor = '#d58c8c';
            thirdIsValid = false;
            setFeedback(messages.patients.form.app_type_feedback);
        }
        if (!appointment?.time) {
            thirdIsValid = false;
            setFeedback(messages.patients.form.time_feedback);
        }
        if (appointment?.user_id === 0) {
            document.getElementById('specialist').style.borderColor = '#d58c8c';
            thirdIsValid = false;
            setFeedback(messages.patients.form.specialist_feedback);
        }
        return thirdIsValid;
    }

    // Next Function
    const handleNext = (e) => {
        e.preventDefault();
        if (step === 1) {
            if (firstStepValidation()) {
                // Save
                setFeedback('');
                setStep(2);
            }
        } else if (step === 2) {
            if (secondStepValidation() && firstStepValidation()) {
                setFeedback('');
                let newFatherFamily = false;
                let newMotherFamily = false;

                if (families?.find(family => family.id === formData.father_family_id && family.name === formData.father_family_id)) {
                    newFatherFamily = true;
                }
                if (families?.find(family => family.id === formData.mother_family_id && family.name === formData.mother_family_id)) {
                    newMotherFamily = true;
                }
                
                dispatch(editPatientRequest({ 
                    ...formData,
                    birthday: moment(formData.birthday).format('YYYY-MM-DD'),
                    father_family_name: newFatherFamily ? formData.father_family_id : null,
                    father_family_id: newFatherFamily ? null : formData.father_family_id,
                    mother_family_name: newMotherFamily ? formData.mother_family_id : null,
                    mother_family_id: newMotherFamily ? null : formData.mother_family_id,
                }));
            }
        } else if (step === 3) {
            if (thirdStepValidation()) {
                setFeedback('');
                // Save
                let appDateTime = `${selectedAppsDate} ${appointment.time}`;
                dispatch(addAppointmentRequest({...appointment, start_date: appDateTime}, history))
            }
        }   
    }

    // Change Step after save
    useEffect(() => {
        if (validStep && step === 2) {
            setStep(3)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validStep])

    const handleAddContactPerson = () => {
        setFormData({
            ...formData,
            contacts: [...formData.contacts, {
                name: {
                    en: '',
                    ar: ''
                },
                phone_number: '',
                email: '',
                relation: '',
                reason_of_contact: '',
            }]
        })
    }

    // Add Family
    useEffect(() => {
        if (formData.father_family_id === 'add') {
            if (formData.mother_family_id === 'add') {
                setFormData({
                    ...formData,
                    mother_family_id: 0,
                })
                setMotherInputValue(null)
            }
            setAddFatherFamily(true);
            setTimeout(() => {
                document.getElementById('addFatherFamily').focus();
                document.getElementById('addFatherFamily').style.borderColor = '#CCC';
            }, 200);
        } else {
            setAddFatherFamily(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.father_family_id])

    useEffect(() => {
        if (formData.mother_family_id === 'add') {
            if (formData.father_family_id === 'add') {
                setFormData({
                    ...formData,
                    father_family_id: 0,
                })
                setFatherInputValue(null)
            }
            setAddMotherFamily(true);
            setTimeout(() => {
                document.getElementById('addMotherFamily').focus();
                document.getElementById('addMotherFamily').style.borderColor = '#CCC';
            }, 200);
        } else {
            setAddMotherFamily(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.mother_family_id])

    useEffect(() => {
        if (valideFamilyName) {
            setTimeout(() => {  
                if (addFatherFamily) {
                    setFormData({ ...formData, father_family_id: families[families?.length - 1]?.id });
                    setFatherInputValue(families[families?.length - 1]?.name);
                } else if (addMotherFamily) {
                    setFormData({ ...formData, mother_family_id: families[families?.length - 1]?.id });
                    setMotherInputValue(families[families?.length - 1]?.name);
                }
                setFamilyData('');
            }, 500);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valideFamilyName])

    useEffect(() => {
        if (families?.length > 0) {
            setFamiliesList([ {id: 0, name: messages.patients.form.father_link_placeholder}, {id: 'add', name: messages.patients.form.add_new_family}, ...families ]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [families])

     // Blur Event Callback - ID Input
     const blurID = useCallback((e) => {
        if (e.target.value !== '') {
            dispatch(validIdRequest({patient_id: id, identification_number: e.target.value}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    // Handle Blur Event - ID input
    useEffect(() => {
        document.getElementById('patientId').addEventListener('blur', blurID);
        return () => {
            document.getElementById('patientId').removeEventListener('blur', blurID);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Validate ID input
    useEffect(() => {
        if (validId || document.getElementById('patientId').value === '' || IDError?.length === 0) {
            document.getElementById('patientId').style.borderColor = '#eee';
            setPatientIDFeedback(null);
        } else {
            document.getElementById('patientId').style.borderColor = '#d58c8c';
            setPatientIDFeedback(IDError);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validId, IDError]);

    return (
        <div className='userform_container'>
            <form>
                <h3 style={{ textAlign: 'center' }}>{messages.patients.form.title}</h3>
                <div className='steps_titles'>
                    <div className={step === 1 ? 'step_title active' : 'step_title'} onClick={() => step > 1 && setStep(1)}>
                        <span>{messages.patients.form.step1}</span>
                    </div>
                    <div className={step === 2 ? 'step_title active' : 'step_title'} onClick={() => step > 2 && setStep(2)}>
                        <span>{messages.patients.form.step2}</span>
                    </div>
                    <div className={step === 3 ? 'step_title active' : 'step_title'} >
                        <span>{messages.patients.form.step3}</span>
                    </div>
                </div>
                <div className={`step ${step === 1 && 'show'}`}>
                    <div className='row'>
                        <div className='col-md-4'>
                            <div className='avatar_input'>
                                <img src={formData.profile_image ? `${process.env.REACT_APP_BASE_URL}${formData.profile_image}` : userAvatar} alt="Avatar" />
                                <div id="avatarContainer"><input type="file" name="avatar" id="avatar" /></div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <label className='required'>{messages.patients.form.family_history}</label>
                            <div className='form-group'>
                                <label className="checkbox-container">{messages.patients.form.yes}
                                    <input type="radio" name="familyHistory" 
                                            checked={formData.has_family_history === 1}
                                            value={1}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    has_family_history: 1,
                                                });
                                            }} />
                                    <span className="checkmark"></span>
                                </label>
                                <label className="checkbox-container">{messages.patients.form.no}
                                    <input type="radio" name="familyHistory" 
                                            checked={formData.has_family_history === 0}
                                            value={0}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData, 
                                                    has_family_history: 0,
                                                });
                                            }} />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div className='col-md-4'></div>
                    </div>
                    <div className="row" style={{ marginBottom: '10px' }}>
                        <div className="col-md-4" style={{ position: 'relative' }}>
                            <label htmlFor="patientId" className='required'>{messages.patients.form.patientId}</label>
                            <input type="text" name="patientId" id="patientId" autoFocus={true}
                                    placeholder={messages.patients.form.patientId_placeholder}
                                    value={formData.identification_number}
                                    onChange={e => {
                                        document.getElementById('patientId').style.borderColor = '#eee';
                                        setPatientIDFeedback(null);
                                        dispatch(resetValidId());
                                        setFormData({ ...formData, identification_number: e.target.value })
                                    }} />
                            <span className="patientID_error">{patientIDFeedback}</span>
                        </div>
                        <div className="col-md-4">
                            <label className='required'>{messages.patients.form.customer_type}</label>
                            <div className='form-group'>
                                <label className="checkbox-container">{messages.patients.form.healthy}
                                    <input type="radio" name="customerType"
                                            value={1}
                                            checked={formData.patient_type === 1}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    patient_type: parseInt(e.target.value),
                                                });
                                            }} />
                                    <span className="checkmark"></span>
                                </label>
                                <label className="checkbox-container">{messages.patients.form.affected}
                                    <input type="radio" name="customerType"
                                            value={2}
                                            checked={formData.patient_type === 2}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    patient_type: parseInt(e.target.value),
                                                });
                                            }} />
                                    <span className="checkmark"></span>
                                </label>
                                <label className="checkbox-container">{messages.patients.form.prenatal}
                                    <input type="radio" name="customerType"
                                            value={3}
                                            checked={formData.patient_type === 3}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    patient_type: parseInt(e.target.value),
                                                });
                                            }} />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <label className='required'>{messages.patients.form.test_type}</label>
                            <div className='form-group'>
                                <label className="checkbox-container">{messages.patients.form.premarital}
                                    <input type="radio" name="testType"
                                            value={1}
                                            checked={formData.test_type === 1}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    test_type: parseInt(e.target.value),
                                                });
                                            }} />
                                    <span className="checkmark"></span>
                                </label>
                                <label className="checkbox-container">{messages.patients.form.pregnancy}
                                    <input type="radio" name="testType"
                                            value={2}
                                            checked={formData.test_type === 2}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    test_type: parseInt(e.target.value),
                                                });
                                            }} />
                                    <span className="checkmark"></span>
                                </label>
                                <label className="checkbox-container">{messages.patients.form.individual}
                                    <input type="radio" name="testType"
                                            value={3}
                                            checked={formData.test_type === 3}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    test_type: parseInt(e.target.value),
                                                });
                                            }} />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="firstName" className='required'>{messages.patients.form.firstname}</label>
                            <input type="text" name="firstName" id="firstName"
                                    placeholder={messages.patients.form.firstname_placeholder}
                                    value={formData.first_name} 
                                    onChange={e => {
                                        document.getElementById('firstName').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, first_name: arabicConvertor(e.target.value) })
                                        }} />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="arname" className='required'>{messages.patients.form.ar_name}</label>
                            <input type="text" name="arname" id="arname"
                                    placeholder={messages.patients.form.ar_name_placeholder}
                                    value={formData.name?.ar}
                                    onChange={e => {
                                        document.getElementById('arname').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, name: { ...formData.name, ar: arabicConvertor(e.target.value) } })
                                        }} />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="enname" className='required'>{messages.patients.form.en_name}</label>
                            <input type="text" name="enname" id="enname"
                                    placeholder={messages.patients.form.en_name_placeholder}
                                    value={formData.name?.en} 
                                    onChange={e => {
                                        document.getElementById('enname').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, name: { ...formData.name, en: e.target.value } })
                                        }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="fatherLink" className='required'>{messages.patients.form.father_link}</label>
                            {
                                addFatherFamily ? (
                                    <div className="family-input">
                                        <input type="text" name="addFatherFamily" id="addFatherFamily"
                                                placeholder={messages.patients.form.add_new_family}
                                                value={familyData} 
                                                onChange={e => setFamilyData(e.target.value)}
                                                onKeyDown={e => {
                                                    if (e.key === "Enter") {
                                                        if (familyData.length > 0) {
                                                            dispatch(addFamilyRequest(familyData))
                                                        }
                                                    }
                                                }} />
                                        <CheckIcon className="add family-icon"
                                            onClick={() => {
                                                if (familyData.length > 0) {
                                                    dispatch(addFamilyRequest(familyData))
                                                }
                                            }}
                                            />
                                        <CloseIcon className="family-icon" 
                                            onClick={() => {
                                                setFormData({ ...formData, father_family_id: 0 });
                                                setFamilyData('');
                                                setAddFatherFamily(false)
                                            }} 
                                                />
                                    </div>
                                ) : (
                                    <div className="auto_complete">
                                        <Autocomplete
                                            id="fatherLinkAutoComplete"
                                            value={familiesList?.find(fam => fam.id === formData.father_family_id)}
                                            onChange={(event, newValue) => {
                                                //document.getElementById('fatherLink').style.borderColor = '#eee';
                                                setFeedback('');
                                                setFormData({ ...formData, father_family_id: newValue.id })
                                            }}
                                            inputValue={fatherInputValue}
                                            onInputChange={(event, newInputValue) => {
                                                setFatherInputValue(newInputValue);
                                            }}
                                            options={familiesList}
                                            getOptionSelected={(option) => option.id === formData.father_family_id}
                                            getOptionLabel={(option) => option.name || fatherInputValue}
                                            style={{ width: '100%' }}
                                            renderInput={(params) => (
                                                <div ref={params.InputProps.ref}>
                                                <input placeholder={messages.patients.form.father_link_placeholder} type="text" name="fatherLink" id="fatherLink" {...params.inputProps} />
                                                </div>
                                            )}
                                        />
                                    </div>
                                )
                            }
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="motherLink" className='required'>{messages.patients.form.mother_link}</label>
                            {
                                addMotherFamily ? (
                                    <div className="family-input">
                                        <input type="text" name="addMotherFamily" id="addMotherFamily"
                                                placeholder={messages.patients.form.add_new_family}
                                                value={familyData} 
                                                onChange={e => setFamilyData(e.target.value)}
                                                onKeyDown={e => {
                                                    if (e.key === "Enter") {
                                                        if (familyData.length > 0) {
                                                            dispatch(addFamilyRequest(familyData))
                                                        }
                                                    }
                                                }} />
                                        <CheckIcon className="add family-icon" 
                                            onClick={() => {
                                                if (familyData.length > 0) {
                                                    dispatch(addFamilyRequest(familyData))
                                                }
                                            }}
                                            />
                                        <CloseIcon className="family-icon" 
                                            onClick={() => {
                                                setFormData({ ...formData, mother_family_id: 0 })
                                                setFamilyData('');
                                                setAddMotherFamily(false)}
                                            } 
                                            />
                                    </div>
                                ) : (
                                    <div className="auto_complete">
                                        <Autocomplete
                                            id="motherLinkAutoComplete"
                                            value={familiesList?.find(fam => fam.id === formData.mother_family_id)}
                                            onChange={(event, newValue) => {
                                                //document.getElementById('motherLink').style.borderColor = '#eee';
                                                setFeedback('');
                                                setFormData({ ...formData, mother_family_id: newValue.id })
                                            }}
                                            inputValue={motherInputValue}
                                            onInputChange={(event, newInputValue) => {
                                                setMotherInputValue(newInputValue);
                                            }}
                                            options={familiesList}
                                            getOptionSelected={(option) => option.id === formData.mother_family_id}
                                            getOptionLabel={(option) => option.name || motherInputValue}
                                            style={{ width: '100%' }}
                                            renderInput={(params) => (
                                                <div ref={params.InputProps.ref}>
                                                <input placeholder={messages.patients.form.mother_link_placeholder} type="text" name="motherLink" id="motherLink" {...params.inputProps} />
                                                </div>
                                            )}
                                        />
                                    </div>
                                )
                            }
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="relationship" className='required'>{messages.patients.form.relationship}</label>
                            <select name="relationship" id="relationship"
                                    value={formData.parents_relationship}
                                    onChange={e => {
                                        document.getElementById('relationship').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, parents_relationship: e.target.value })
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.relationship_placeholder}</option>
                                {relationshipList.map(relation => <option key={relation.id} value={relation.id}>{relation.name}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="birthday" className='required'>{messages.patients.form.birthday}</label>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    id="date-picker-dialog"
                                    format="dd/MM/yyyy"
                                    emptyLabel="DD/MM/YYYY"
                                    value={selectedBirthDate}
                                    onChange={setSelectedBirthDate}
                                    className="datetime-picker"
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="birthplaceId" className='required' >{messages.patients.form.birth_city}</label>
                            <select name="birthplaceId" id="birthplaceId"
                                    value={formData.birthplace_id}
                                    onChange={e => {
                                        document.getElementById('birthplaceId').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, birthplace_id: e.target.value })
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.birth_city_placeholder}</option>
                                {allCities?.map(city => <option key={city.id} value={city.id}>{city.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="originCityId" className='required' >{messages.patients.form.origin_city}</label>
                            <select name="originCityId" id="originCityId"
                                    value={formData.origin_city_id}
                                    onChange={e => {
                                        document.getElementById('originCityId').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, origin_city_id: e.target.value })
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.origin_city_placeholder}</option>
                                {allCities?.map(city => <option key={city.id} value={city.id}>{city.name}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="gender" className='required'>{messages.patients.form.gender}</label>
                            <select name="gender" id="gender"
                                    value={formData.gender_type}
                                    onChange={e => {
                                        document.getElementById('gender').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, gender_type: e.target.value })
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.gender_placeholder}</option>
                                {genderList?.map(gender => <option key={gender.id} value={gender.id}>{gender.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="status" className='required'>{messages.patients.form.marital_status}</label>
                            <select name="status" id="status"
                                    value={formData.social_status}
                                    onChange={e => {
                                        document.getElementById('status').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, social_status: e.target.value })
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.marital_status_placeholder}</option>
                                {maritalStatus?.map(status => <option key={status.id} value={status.id}>{status.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4"></div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="requestChannel" className='required'>{messages.patients.form.request_channel}</label>
                            <select name="requestChannel" id="requestChannel"
                                    value={formData.source}
                                    onChange={e => {
                                        document.getElementById('requestChannel').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, source: e.target.value })
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.request_channel_placeholder}</option>
                                {requestResourcesOptions?.map(source => <option key={source.id} value={source.id}>{source.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="dealingType" className='required'>{messages.patients.form.dealing_type}</label>
                            <select name="dealingType" id="dealingType"
                                    value={formData.contact_method}
                                    onChange={e => {
                                        document.getElementById('dealingType').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, contact_method: e.target.value })
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.dealing_type_placeholder}</option>
                                {dealingTypes?.map(type => <option key={type.id} value={type.id}>{type.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="subsPrograms" className='required'>{messages.patients.form.subscription_programs}</label>
                            <select name="subsPrograms" id="subsPrograms"
                                    value={formData.program_id}
                                    onChange={e => {
                                        document.getElementById('subsPrograms').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, program_id: e.target.value })
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.subscription_programs_placeholder}</option>
                                {programs.map(program => <option key={program.id} value={program.id}>{program.name}</option>)}
                            </select>
                        </div>
                    </div>
                </div>
                <div className={`step ${step === 2 ? 'show' : ''}`}>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="phone" className='required'>{messages.patients.form.mobile}</label>
                            <PhoneInputComponent name="phone" id="phone" lang={lang}
                                myplaceholder={messages.users.form.mobile_placeholder}
                                myvalue={formData.phone_number?.replace(/\+/g, "")}
                                onValueChange={(val) => {
                                    document.getElementById('phone').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, phone_number: `+${val}` })
                                    }}
                                />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="email">{messages.patients.form.email}</label>
                            <input type="email" name="email" id="email"
                                    placeholder={messages.patients.form.email_placeholder}
                                    value={formData.email} 
                                    onChange={e => {
                                        document.getElementById('email').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, email: e.target.value })
                                        }} />
                        </div>
                        <div className="col-md-4"></div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="governorate" className='required'>{messages.patients.form.governorate}</label>
                            <select name="governorate" id="governorate"
                                    value={formData.region_id}
                                    onChange={e => {
                                        document.getElementById('governorate').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, region_id: e.target.value })
                                        setSelectedRegion(e.target.value)
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.governorate_placeholder}</option>
                                {regions?.map(gov => <option key={gov.id} value={gov.id}>{gov.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="cityId" className='required'>{messages.patients.form.city}</label>
                            <select name="cityId" id="cityId"
                                    value={formData.city_id}
                                    onChange={e => {
                                        document.getElementById('cityId').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, city_id: e.target.value })
                                        }}
                                    >
                                <option value={0}>{messages.patients.form.city_placeholder}</option>
                                    {citiesList?.map(city => <option key={city.id} value={city.id}>{city.name}</option>)}                                
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="address">{messages.patients.form.address}</label>
                            <input type="text" name="address" id="address"
                                    placeholder={messages.patients.form.address_placeholder}
                                    value={formData.address} 
                                    onChange={e => {
                                        document.getElementById('address').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, address: e.target.value })
                                        }} />
                        </div>
                    </div>
                    <h3 style={{ marginTop: '20px' }}>{messages.patients.form.contact_details_point}</h3>
                    {formData?.contacts?.map((contact, index) => (
                        <div className="contact_details" key={index}>
                            <div className="row">
                                <div className="col-md-4">
                                    <label htmlFor="contact_arname" className='required'>{messages.patients.form.contact_namear}</label>
                                    <input type="text" name="contact_arname" id="contact_arname"
                                            placeholder={messages.patients.form.contact_namear_placeholder}
                                            value={formData.contacts[index]?.name?.ar}
                                            onChange={e => {
                                                document.getElementById('contact_arname').style.borderColor = '#eee';
                                                setFeedback('');
                                                setFormData({ 
                                                    ...formData, 
                                                    contacts: formData.contacts?.map((con, i) => {
                                                        if (i === index) {
                                                            return { ...con, name: { ...formData.contacts[i]?.name ,ar: arabicConvertor(e.target.value) } }
                                                        }
                                                        return con
                                                    })
                                                })
                                                }} />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="contact_enname" className='required'>{messages.patients.form.contact_nameen}</label>
                                    <input type="text" name="contact_enname" id="contact_enname"
                                            placeholder={messages.patients.form.contact_nameen_placeholder}
                                            value={formData.contacts[index]?.name?.en}
                                            onChange={e => {
                                                document.getElementById('contact_enname').style.borderColor = '#eee';
                                                setFeedback('');
                                                setFormData({ 
                                                    ...formData,
                                                    contacts: formData.contacts?.map((con, i) => {
                                                        if (i === index) {
                                                            return { ...con, name: {  ...formData.contacts[i]?.name, en: e.target.value } }
                                                        }
                                                        return con
                                                    })
                                                })
                                                }} />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="contact_relation" className='required'>{messages.patients.form.relation}</label>
                                    <input type="text" name="contact_relation" id="contact_relation"
                                            placeholder={messages.patients.form.relation_placeholder}
                                            value={formData.contacts[index]?.relation}
                                            onChange={e => {
                                                document.getElementById('contact_relation').style.borderColor = '#eee';
                                                setFeedback('');
                                                setFormData({ 
                                                    ...formData,
                                                    contacts: formData.contacts?.map((con, i) => {
                                                        if (i === index) {
                                                            return { ...con, relation: e.target.value }
                                                        }
                                                        return con
                                                    })
                                                })
                                                }} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <label htmlFor="contact_mobile" className='required'>{messages.patients.form.mobile}</label>
                                    <PhoneInputComponent name="contact_mobile" id="contact_mobile" lang={lang}
                                        myplaceholder={messages.users.form.mobile_placeholder}
                                        myvalue={formData.contacts[index]?.phone_number?.replace(/\+/g, "")}
                                        onValueChange={(val) => {
                                            document.getElementById('contact_mobile').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ 
                                                ...formData, 
                                                contacts: formData.contacts?.map((con, i) => {
                                                    if (i === index) {
                                                        return { ...con, phone_number: `+${val}` }
                                                    }
                                                    return con
                                                })
                                            })
                                            }}
                                        />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="contact_email">{messages.patients.form.email}</label>
                                    <input type="text" name="contact_email" id="contact_email"
                                            placeholder={messages.patients.form.email_placeholder}
                                            value={formData.contacts[index]?.email}
                                            onChange={e => {
                                                document.getElementById('contact_email').style.borderColor = '#eee';
                                                setFeedback('');
                                                setFormData({ 
                                                    ...formData, 
                                                    contacts: formData.contacts?.map((con, i) => {
                                                        if (i === index) {
                                                            return { ...con, email: e.target.value }
                                                        }
                                                        return con
                                                    })
                                                })
                                                }} />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="contact_reason" className='required'>{messages.patients.form.contact_reason}</label>
                                    <input type="text" name="contact_reason" id="contact_reason"
                                            placeholder={messages.patients.form.contact_reason_placeholder}
                                            value={formData.contacts[index]?.reason_of_contact}
                                            onChange={e => {
                                                document.getElementById('contact_reason').style.borderColor = '#eee';
                                                setFeedback('');
                                                setFormData({ 
                                                    ...formData, 
                                                    contacts: formData.contacts?.map((con, i) => {
                                                        if (i === index) {
                                                            return { ...con, reason_of_contact: e.target.value }
                                                        }
                                                        return con
                                                    })
                                                })
                                                }} />
                                </div>
                            </div>
                            <div className='hr-container'>
                                <span className="myHr">&nbsp;</span> 
                                <CancelPresentationIcon onClick={() => {
                                    setFormData({ 
                                        ...formData, 
                                        contacts: formData.contacts?.filter((con, i) => i !== index)
                                    })
                                }} />
                            </div>
                        </div>
                    ))}
                    <h6 className='add_new_person' onClick={handleAddContactPerson}><AddCircleOutlineIcon /> {messages.patients.form.add_new_person}</h6>
                </div>
                <div className={`step ${step === 3 ? 'show' : ''}`}>
                   <div className='row'>
                        <div className="col-md-8">
                            <Schedule 
                                currentDate={selectedAppsDate}
                                userId={selectedUserId}
                            />
                        </div>
                        <div className="col-md-4">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} local={lang === 'ar' ? 'ar-SA' : 'en-US'}>
                                <DatePicker
                                    autoOk
                                    disableToolbar={true}
                                    orientation="landscape"
                                    variant="static"
                                    openTo="date"
                                    value={selectedAppsDate}
                                    onChange={(date) => setSelectedAppsDate(moment(date).format('YYYY-MM-DD'))}
                                />
                            </MuiPickersUtilsProvider>
                            <div style={{ marginTop: '20px' }}>
                                <label htmlFor="specialist" >{messages.patients.form.specialist}</label>
                                <select name="specialist" id="specialist"
                                        style={{ width: '100%' }}
                                        value={selectedUserId}
                                        onChange={e => {
                                            document.getElementById('specialist').style.borderColor = '#eee';
                                            setFeedback('');
                                            setSelectedUserId(e.target.value);
                                            setAppointment({ ...appointment, user_id: e.target.value })
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.specialist_placeholder}</option>
                                    {specialistList?.map(user => <option key={user.id} value={user.id}>{user.name}</option>)}
                                </select>
                            </div>
                            <div className="timepicker-container">
                                {availableTimes?.map(time => 
                                    <div key={time.id} className={`timepicker-item ${selectedTime === time.id && 'active'}`} onClick={() => {
                                        setAppointment({ ...appointment, time: time.value })
                                        setSelectedTime(time.id)
                                    }}>
                                        {time.text}
                                    </div>
                                )}
                            </div>
                            <div>
                                <label htmlFor="appTypes" >{messages.patients.form.app_type}</label>
                                <select name="appTypes" id="appTypes"
                                        style={{ width: '100%' }}
                                        value={appointment.type}
                                        onChange={e => {
                                            document.getElementById('appTypes').style.borderColor = '#eee';
                                            setFeedback('');
                                            setAppointment({ ...appointment, type: e.target.value })
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.app_type_placeholder}</option>
                                    {appTypes?.map(type => <option key={type.id} value={type.id}>{type.name}</option>)}
                                </select>
                            </div>
                            <div>
                                <label htmlFor="appStatus" >{messages.patients.form.app_status}</label>
                                <select name="appStatus" id="appStatus"
                                        style={{ width: '100%' }}
                                        value={appointment.purpose}
                                        onChange={e => {
                                            document.getElementById('appStatus').style.borderColor = '#eee';
                                            setFeedback('');
                                                if (parseInt(e.target.value) === 1) {
                                                    setAppointment({ ...appointment, purpose: e.target.value })
                                                }
                                            }}
                                        >
                                    <option value={0}>{messages.patients.form.app_status_placeholder}</option>
                                    {appStatus?.map(status => <option key={status.id} value={status.id} disabled={status.id === 2 || status.id === 3}>{status.name}</option>)}
                                </select>
                            </div>
                        </div>
                   </div>
                </div>
                <div className='form-footer'>
                    <p>&nbsp;{feedback}</p>
                    <div className="actions">
                        {
                            step !== 1 && (
                                <button type="button" className="cancel" onClick={(e) => setStep(step === 3 ? 2 : 1)}>
                                    {messages.users.form.btn_back}
                                </button>
                            )
                        }
                        <button type="button" onClick={(e) => handleNext(e)} disabled={addFatherFamily || addMotherFamily}>
                            {step === 3 ? messages.users.form.btn_save : messages.users.form.btn_next}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default injectIntl(PatientProfileForm);
